// src/pages/landing/Connect4VideoChat.jsx
import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function Connect4VideoChat() {
  return (
    <>
      <SEO
        title="Play Connect 4 & 4 in a Row Online - Video Chat with Strangers"
        description="Play 4 in a Row (Connect 4) with strangers in a live random video chat. Match up, break the ice with games, and win points on Talkvee."
        pathname="/connect-4-video-chat"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Connect 4 Video Chat", "item": "https://talkvee.com/connect-4-video-chat" }
          ]
        }}
      />

      <div className="landing-wrapper">
        {/* Updated Hero with focus on 4 in a Row and Live Play */}
        <section className="landing-hero" style={{ background: 'linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)', color: 'white', padding: '60px 20px', borderRadius: '0 0 20px 20px' }}>
          <h1 className="landing-title" style={{ color: 'white' }}>Play 4 in a Row & Connect 4 Online</h1>
          <p className="landing-subtitle" style={{ color: 'rgba(255,255,255,0.9)' }}>
            The best way to match with people online. Start a live video chat and challenge your partner to a classic game of 4 in a Row directly on your screen.
          </p>
          <Link to="/" className="tv-cta" style={{ background: '#facc15', color: '#854d0e', fontWeight: 'bold' }}>
            📹 Start Video Chat & Play Now
          </Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Match, Chat, and Play</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h4 style={{margin: '0 0 10px', color: '#1e293b', fontSize: '1.1rem'}}>🔴 Instant Matches</h4>
              <p style={{margin: 0, color: '#475569', lineHeight: '1.6'}}>
                Match with people from around the world instantly. Use our built-in 4 in a Row game to break the ice and start a real conversation.
              </p>
            </div>
            <div style={{background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h4 style={{margin: '0 0 10px', color: '#1e293b', fontSize: '1.1rem'}}>🟡 Competitive Fun</h4>
              <p style={{margin: 0, color: '#475569', lineHeight: '1.6'}}>
                It's not just a chat; it's a challenge. Win matches to climb the global leaderboard and prove you're the best at Connect 4.
              </p>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "How do I play 4 in a Row on video chat?",
              a: "Once you match with a stranger on Talkvee, click the game icon on your screen. Select Connect 4 to send an invitation to your partner instantly."
            },
            {
              q: "Is it free to play Connect 4 with strangers?",
              a: "Yes! Talkvee is a completely free random video chat platform where you can play games without any hidden costs."
            },
            {
              q: "Can I play 4 in a Row on my phone?",
              a: "Absolutely. Talkvee is fully optimized for mobile browsers, allowing you to play and video chat on the go."
            },
            {
              q: "Are the games live?",
              a: "Yes! You play in real-time against the person you are currently video chatting with."
            }
          ]}
        />
      </div>
    </>
  );
}